import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  props: {
    type: String,
    successPageId: {
      type: String,
      default: "transfer-succes",
    },
  },
  data() {
    return {
      id: this.$options.name,
      link: "",
      transfer: "",
      error: false,
      selectedOptionKey: "email",
      options: {
        email: {
          formContent: {
            optionsData: {
              placeholder: i18n.t("common.email_address"),
            },
            enterFunc: () => {},
            focus: true,
            formData: {
              title: i18n.t("transfer.transfer_files"),
              icon: "transfer",
              label: i18n.t("transfer.transfer_files"),
              name: "emails",
            },
          },
          buttons: [
            {
              type: "emitter",
              colorScheme: "light",
              emitterName: `${this.$options.name}-switch`,
              emitterData: { id: this.$options.name, switchKey: "link" },
              value: i18n.t("transfer.get_download_link"),
              icon: "link",
            },
            {
              type: "emitter",
              colorScheme: "dark",
              emitterName: `${this.$options.name}-emailTransfer`,
              emitterData: { id: this.$options.name },
              value: i18n.t("transfer.transfer"),
            },
          ],
        },
        link: {
          formContent: {
            optionsData: {
              placeholder: "",
              value: "",
            },
            enterFunc: () => {},
            focus: true,
            formData: {
              title: i18n.t("transfer.transfer_files"),
              icon: "transfer",
              label: "",
              name: "link",
            },
          },
          buttons: [
            {
              type: "emitter",
              colorScheme: "light",
              emitterName: `${this.$options.name}-switch`,
              emitterData: { id: this.$options.name, switchKey: "email" },
              value: i18n.t("transfer.send_with_email"),
              icon: "email",
            },
            {
              type: "emitter",
              colorScheme: "dark",
              emitterName: `${this.$options.name}-linkTransfer`,
              emitterData: { id: this.$options.name },
              value: i18n.t("common.copy_link"),
            },
          ],
        },
      },
    };
  },
  created() {
    //preform setup
    this.setupEnterFuncs();

    //create transfer
    this.addTransfer();

    EventBus.$on(`${this.id}-switch`, (data) => {
      this.selectedOptionKey = data.switchKey;
    });

    EventBus.$on(`${this.id}-emailTransfer`, () => {
      this.sendTransfer();
    });

    EventBus.$on(`${this.id}-linkTransfer`, () => {
      this.copyLink();
    });
  },
  methods: {
    setupEnterFuncs() {
      this.options.email.formContent.enterFunc = (e) => {
        e.preventDefault();
        this.sendTransfer();
      };
      this.options.link.formContent.enterFunc = (e) => {
        e.preventDefault();
        this.copyLink();
      };
    },
    addTransfer() {
      const formData = new FormData();

      formData.append(
        "folders",
        JSON.stringify(this.$store.state.transferItems.selectedFolders)
      );
      formData.append(
        "files",
        JSON.stringify(this.$store.state.transferItems.selectedFiles)
      );

      formData.append(
        "collection",
        this.$store.state.transferItems.collection.id
      );

      this.$axios.post(`${baseUrl}/transferadd`, formData).then((r) => {
        this.link = r.data.link;
        this.transfer = r.data.transfer;

        //set the link value
        this.options.link.formContent.optionsData.value = r.data.link;
      });
    },
    sendTransfer() {
      //get emails
      const formData = new FormData(
        this.$refs[`form${this.selectedOptionKey}`].$el.querySelector("form")
      );

      formData.append("transfer", this.transfer);

      this.$axios.post(`${baseUrl}/transfersend`, formData).then((r) => {
        if (r.data.success == false && r.data.msg == "email_invalid") {
          this.error = true;
        }
        if (r.data.success == true && r.data.msg == "transfer_send") {
          //transfer succesfull so go to succes page
          EventBus.$emit(`mobile-transfer-updateStep`, {
            id: this.successPageId,
            lastStepId: "",
            data: {
              //add email for display purposes
              email: formData.get("emails"),
            },
          });
        }
      });
    },
    copyLink() {
      navigator.clipboard.writeText(this.link);
    },
  },
};
